import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from '@RankHR/People/queries-core'
import { isRef, ref, Ref } from 'vue'
export function usePeopleByRegionQueryV1(regionId?: string | Ref<string>, onlyEnabled?: boolean | Ref<boolean>, ) {
	const _regionId = isRef<string>(regionId) ? regionId : ref<string>(regionId)
	const _onlyEnabled = isRef<boolean>(onlyEnabled) ? onlyEnabled : ref<boolean>(onlyEnabled)
	const result = {
		regionId: _regionId,
		onlyEnabled: _onlyEnabled,
		...useQuery(() => new q.PeopleByRegionQueryV1(_regionId.value, _onlyEnabled.value))
	}
	return {
		...result,
		runPeopleByRegionQueryV1: result.run,
		modelPeopleByRegionQueryV1: result.model,
	}
}

export function usePersonVotesQueryV1(personId?: string | Ref<string>, ) {
	const _personId = isRef<string>(personId) ? personId : ref<string>(personId)
	const result = {
		personId: _personId,
		...useQuery(() => new q.PersonVotesQueryV1(_personId.value))
	}
	return {
		...result,
		runPersonVotesQueryV1: result.run,
		modelPersonVotesQueryV1: result.model,
	}
}

